import { DatePicker } from 'antd';
import 'dayjs/locale/ru';
import locale from 'antd/es/date-picker/locale/ru_RU';
import type { PeriodFilterProps } from '../reports.types';

const { RangePicker } = DatePicker;

const PeriodFilter = ({ onChange }: PeriodFilterProps) => {
  return (
    <>
      Период:
      <RangePicker
        locale={locale}
        style={{ marginTop: 7, width: '100%' }}
        onChange={(_value, dateString) => onChange(dateString)}
      />
    </>
  );
};

export default PeriodFilter;
